var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseElFormItem',{attrs:{"label":"啟用通知"}},[_c('BaseElSwitch',{attrs:{"active-text":"開啟","inactive-text":"關閉"},model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }